import Vue from 'vue'
import { mapState } from 'vuex'
import Badges from './Badges'
import { GigJobStages } from '@/constants/gig/gigJobStages'
import GigOfferListItem from '@/models-ts/gigs/GigOfferListItem'
import { Badge } from '../Badge'

export default Vue.extend<any, any, any, any>({
  props: {
    gig: GigOfferListItem,
  },
  computed: {
    ...mapState({
      userId: (state: any) => state.user?.id,
    }),
    isCompleted() {
      return [GigJobStages.PAYED, GigJobStages.RETURNED, GigJobStages.DISPUTED].includes(this.gig?.job?.stage)
    },
    isClient() {
      return this.gig?.customerId === this.userId
    },
    hasReview(): boolean {
      if (!this.isCompleted) return false

      return this.isClient ? this.gig.customerLeftReview : this.gig.freelancerLeftReview
    },
    badge(): Badge | undefined {
      const stage = this.gig.job?.stage as GigJobStages
      if (stage === GigJobStages.IN_PROGRESS) return Badges.InProgress
      if (stage === GigJobStages.BLOCKED) return Badges.Dispute
      if (!this.hasReview) return Badges.Review // Save order!
      switch (stage) {
        case GigJobStages.DISPUTED:
          return Badges.Resolved
        case GigJobStages.RETURNED:
          return Badges.Refunded
        case GigJobStages.PAYED:
          return Badges.Completed
      }
    },
  },
})
